import { render, staticRenderFns } from "./report-card.vue?vue&type=template&id=62d33685&"
import script from "./report-card.vue?vue&type=script&lang=ts&"
export * from "./report-card.vue?vue&type=script&lang=ts&"
import style0 from "./report-card.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports